import "./cancel-modal.scss";
import { CancelModalProps } from "@/types/interfaces";
import { FC } from "react";
import * as Dialog from "@radix-ui/react-dialog";

const CancelModal: FC<CancelModalProps> = ({
  open,
  onClose,
  onCancel,
  clientName,
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="modal-overlay" />
        <Dialog.Content className="modal-content cancel-modal">
          <Dialog.Title className="h1 modal-title">
            Cancel sending measurements?
          </Dialog.Title>
          <div className="modal-body">
            {/* asChild: Radix stamps aria-describedby on the existing <p>, DOM unchanged */}
            <Dialog.Description asChild>
              <p className="p2">
                You are currently in the middle of sending an avatar to{" "}
                <strong style={{ color: "black" }}>{clientName}</strong>. Do you
                want to cancel?
              </p>
            </Dialog.Description>
          </div>
          <div className="buttons">
            <button onClick={onCancel} className="secondary-button">
              Yes, cancel
            </button>
            <button onClick={onClose} className="primary-button">
              No, keep going
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default CancelModal;
